<template>
  <div v-if="approveInfo.id">
    <DetailvueApproval v-if="approveInfo.approve_data" :approveInfo="approveInfo" @refresh="getVisitorInfoDetail"></DetailvueApproval>
    <DetailOld v-else :approveInfo="approveInfo" @refresh="getVisitorInfoDetail"></DetailOld>
  </div>
  <van-empty v-else description="暂无数据" />
</template>
<script lang="ts">
import { defineComponent, ref } from "vue";
import DetailOld from "./components/DetailOld.vue";
import DetailvueApproval from "./components/DetailvueApproval.vue";
import Account from "@/api/account";
import { Empty } from "vant";

export default defineComponent({
  name: "approval",
  props: {},
  components: {
    DetailOld,
    DetailvueApproval,
    "van-empty": Empty,
  },
  setup() {
    const approveInfo = ref<any>({});
    const touser_id = ref();
    const getVisitorInfoDetail = async () => {
      const [err, data] = await Account.getVisitorInfoDetail(touser_id.value);
      approveInfo.value = data || {};
    };

    return {
      approveInfo,
      touser_id,
      getVisitorInfoDetail,
    };
  },
  created() {
    this.touser_id = this.$route.query.touser_id || '';
    this.getVisitorInfoDetail();
  },
});
</script>